module.exports = __webpack_public_path__ + "static/media/chip_close_icon.673a61fd.svg";